export default __webpack_public_path__ + "static/media/outfit_trousersshirt.158ac1e0.png";